const deps = [
  require('angular-ui-router'),
  require('ui/web/form').name,
  require('ui/bk/clientDetails').name,
];

module.exports = angular
  .module('bench.app.mainapp.details.teamComments', deps)

  .config($stateProvider =>
    $stateProvider.state('bench.details.teamComments', {
      url: '/team-comments',
      views: {
        '': {
          controller($stateParams) {
            this.clientId = $stateParams.clientId;
            return this;
          },
          controllerAs: 'vm',
          template: `
            <bl-client-details 
              client-id="{{vm.clientId}}"
              show-team-comments="true"
            />
          `,
        },
      },
    }),
  );
